/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        name: "我的砍价",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "icon_url",
                name: "图标",
                type: "img",
                memo: "建议尺寸：60px*60px"
            },
            {
                key: "name",
                name: "文案",
                type: "text",
                memo: "名称最多10个汉字",
                max: 10
            }
        ]
    }
];
export default config;